"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginFailed = LoginFailed;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function LoginFailed(_ref) {
  var id = _ref.id,
    show = _ref.show,
    onHide = _ref.onHide,
    title = _ref.title,
    subTitle = _ref.subTitle,
    btnYes = _ref.btnYes;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    id: id,
    show: show,
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-danger text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "glyphicon glyphicon-remove-sign",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-times-circle"
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("p", null, subTitle)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "light",
    "aria-label": "press tab and enter to close invalid passcode modal",
    type: "button",
    className: "shadow-none ",
    onClick: onHide
  }, btnYes))));
}
var _default = LoginFailed;
exports.default = _default;